import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDependentDetails } from '../services/fn-api/Beneficiary';
import { BENEFICIARY_DEPENDENTS_KEY } from 'src/utils/constants/queryKeys';

export const useUpdateDependentDetails = () => {
  const queryClient = useQueryClient();

  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      const { beneId, ...rest } = data;
      return updateDependentDetails(rest);
    },
    onSuccess: (_, data) => {
      const beneId = data.beneId as number;
      queryClient.refetchQueries({
        queryKey: [BENEFICIARY_DEPENDENTS_KEY, beneId],
      });
    },
  });
};
